module.exports = __webpack_public_path__ + "static/media/pig.e12deacf.PNG";